import jwtDecode from 'jwt-decode';

const getTokenExpirationDate = (token: string | null): Date | null => {
  const decoded: any = jwtDecode(token ?? '');
  if (!decoded.exp) {
    return null;
  }

  // The `exp` field typically is in seconds, convert it to milliseconds
  const date = new Date(0);
  date.setUTCSeconds(decoded.exp);
  return date;
};

const isTokenExpired = (token: string | null): boolean => {
  if (token === null || token === '' || token === undefined) return false;
  const expirationDate = getTokenExpirationDate(token);
  if (expirationDate) return expirationDate < new Date();
  return false;
};

export default { isTokenExpired };
